import React from 'react';
import { SmartTagsWysiwygLayoutProps } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';
import QuillWysiwygLayout from '../../../form/input/layout/QuillWysiwygLayout';
import HowToUseSmartTagsLink from '../../../form/HowToUseSmartTagsLink';
import ShadcnSmartTagsWysiwygLayout from './ShadcnSmartTagsWysiwygLayout';
import useSmartTagsMentionModule from './useSmartTagsMentionModule';

import './SmartTagsWysiwygLayout.scss';

function SmartTagsQuillLayoutWrapper(props: SmartTagsWysiwygLayoutProps) {
  const { modules, quillRef } = useSmartTagsMentionModule(props);

  return (
    <>
      {!props.hideHowToUseLink && (
        <HowToUseSmartTagsLink />
      )}
      <QuillWysiwygLayout
        {...props}
        modules={modules}
        quillRef={quillRef}
      />
    </>
  );
}

export default function SmartTagsWysiwygLayout(
  props: SmartTagsWysiwygLayoutProps,
) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnSmartTagsWysiwygLayout {...props} />;
  } else {
    return <SmartTagsQuillLayoutWrapper {...props} />;
  }
}
